var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2159_17903",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2159_17903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30016 11.9833L5.16683 9.84999L5.8835 9.13333L7.30016 10.55L10.1168 7.73333L10.8335 8.45L7.30016 11.9833ZM3.5335 14.3333C3.20016 14.3333 2.91683 14.2167 2.6835 13.9833C2.45016 13.75 2.3335 13.4667 2.3335 13.1333V4.2C2.3335 3.86666 2.45016 3.58333 2.6835 3.35C2.91683 3.11666 3.20016 2.99999 3.5335 2.99999H4.46683V1.58333H5.4835V2.99999H10.5335V1.58333H11.5335V2.99999H12.4668C12.8002 2.99999 13.0835 3.11666 13.3168 3.35C13.5502 3.58333 13.6668 3.86666 13.6668 4.2V13.1333C13.6668 13.4667 13.5502 13.75 13.3168 13.9833C13.0835 14.2167 12.8002 14.3333 12.4668 14.3333H3.5335ZM3.5335 13.3333H12.4668C12.5113 13.3333 12.5557 13.3111 12.6002 13.2667C12.6446 13.2222 12.6668 13.1778 12.6668 13.1333V6.86666H3.3335V13.1333C3.3335 13.1778 3.35572 13.2222 3.40016 13.2667C3.44461 13.3111 3.48905 13.3333 3.5335 13.3333Z",
    fill: "#366EE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.e6e127ae066f56abcf5bb672d8478646.svg";
export { ForwardRef as ReactComponent };